import * as React from 'react'
import { Box, Form, Loader, Typography } from 'cs-kevlar-react'
import { Grid } from 'cs-kevlar-react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import { ShardMigration } from 'api'
import {
  getShardMigrationStatusLabel,
  serverDateToLocaleDateTimeString,
} from 'utils'

interface DatabaseConfigurationStatusProps {
  shardMigration: ShardMigration
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    key: {
      color: theme.palette.neutralButton.main,
    },
    whiteSpacePre: {
      whiteSpace: 'pre-line',
    },
  }),
)

export const DatabaseConfigurationStatus: React.FunctionComponent<DatabaseConfigurationStatusProps> = ({
  shardMigration,
}) => {
  const classes = useStyles({})
  return (
    <React.Fragment>
      <Grid item xs={4}>
        <Typography variant="body2" display="inline" className={classes.key}>
          Migration Status
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography variant="body2" display="inline">
          {getShardMigrationStatusLabel(shardMigration.status)}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body2" display="inline" className={classes.key}>
          Source Shard
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography variant="body2" display="inline">
          {shardMigration.sourceDatabaseShardId}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body2" display="inline" className={classes.key}>
          Destination Shard
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography variant="body2" display="inline">
          {shardMigration.destinationDatabaseShardId}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body2" display="inline" className={classes.key}>
          Started On
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography variant="body2" display="inline">
          {serverDateToLocaleDateTimeString(shardMigration.startedOn)}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body2" display="inline" className={classes.key}>
          Updated On
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography variant="body2" display="inline">
          {serverDateToLocaleDateTimeString(shardMigration.updatedOn)}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body2" display="inline" className={classes.key}>
          Ended On
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography variant="body2" display="inline">
          {serverDateToLocaleDateTimeString(shardMigration.endedOn)}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body2" display="inline" className={classes.key}>
          Message
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography
          variant="body2"
          display="inline"
          className={classes.whiteSpacePre}
        >
          {shardMigration.message}
        </Typography>
      </Grid>
    </React.Fragment>
  )
}
